export const BlockGallery = (props) => {
    const { datas, id } = props;
    let target;
    return (
        <div className="gallery">
            {datas.map((el, i) => {
                return (
                    <div className="wrapper" key={i}>
                        <img id={`${id}-${i}`} className="gallery-small" alt={`image-${i}`} src={el} onClick={(e) => {
                            target = document.getElementById(`big-${id}-${i}`);
                            target.classList.remove('hide');
                            target.classList.add('show');
                        }} />
                        <img id={`big-${id}-${i}`} className="gallery-big hide" alt={`image-${i}`} src={el} onClick={(e) => {
                            target = document.getElementById(e.target.id);
                            target.classList.remove('show');
                            target.classList.add('hide');
                        }} />
                    </div>
                )
            })}
        </div>
    )
}